<div [froalaEditor]="getEditorOptions()" [(froalaModel)]="content"></div>